import sessionStorageKeys from "../browser/sessionStorageKeys";
import { clearLoggedInUserCookie } from "./cookies";
import { msalInstance } from "../auth/msalInstance";

export default function LogoutRedirect() {
  clearLoggedInUserCookie();

  if (sessionStorage.getItem(sessionStorageKeys.ALL_SESSIONS_ELECTRONIC_SIGNATURE_KEY)) {
    sessionStorage.removeItem(sessionStorageKeys.ALL_SESSIONS_ELECTRONIC_SIGNATURE_KEY);
  }
  if (localStorage.getItem("fiveMinuteCountdown")) {
    localStorage.removeItem("fiveMinuteCountdown");
  }
  if (localStorage.getItem(sessionStorageKeys.NORTH_PASS_KEY)) {
    localStorage.removeItem(sessionStorageKeys.NORTH_PASS_KEY);
  }
  if (sessionStorage.getItem(sessionStorageKeys.CAMPUS_MODAL_DISMISSED_KEY)) {
    sessionStorage.removeItem(sessionStorageKeys.CAMPUS_MODAL_DISMISSED_KEY);
  }
  msalInstance.logoutRedirect();
}
